import { render, staticRenderFns } from "./VoucherSummary.vue?vue&type=template&id=317b8a7a&"
import script from "./VoucherSummary.vue?vue&type=script&lang=js&"
export * from "./VoucherSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports